import { graphql } from 'gql/generated'

export const ADD_TRIP_DRIVER_RSVP_NOTE = graphql(`
  mutation AddTripDriverRSVPNote($input: AddTripDriverRSVPNoteInput!) {
    addTripDriverRSVPNote(input: $input)
  }
`)

export const ADD_TRIP_DRIVER_REAL_DISTANCE_NOTE = graphql(`
  mutation AddTripDriverRealDistanceNote($input: RegisterTripOdometerDistanceInput!) {
    registerTripOdometerDistance(input: $input)
  }
`)
